
<div class="email-preview-card border rounded mb-4" :style="cardStyle">
    <!-- Email Header -->
    <div class="email-header p-3 position-relative"
        style="background-color: #D7D7D7; border-bottom: 1px solid #E0E0E0;">
        <!-- Corner Ribbon -->
        <div class="corner-ribbon" :style="ribbonStyle">SAMPLE</div>
        <div style="font-size: 13px;">
            <div><span style="width: 60px; display: inline-block;">From:</span>
                <b>no-reply@fastvisa.us</b>
            </div>
            <div class="d-flex mt-1 align-items-center">
                <span style="width: 60px; display: inline-block;">To:</span>
                <!-- Recipient line that truncates based on available width -->
                <div class="d-flex align-items-center flex-wrap recipient-line" ref="recipientContainer">
                    <span
                        ref="recipientText"
                        class="recipient-text"
                        :style="recipientTextStyle"
                    >
                        <template v-if="visibleRecipientItems.length > 0">
                            <span
                                v-for="(recipient, idx) in visibleRecipientItems"
                                :key="`${recipient.id || recipient.email || 'recipient'}-${idx}`"
                            >
                                <span>{{ recipient.email }}</span>
                                <span v-if="isRecipientInactive(recipient)" class="recipient-inactive-label">(Inactive)</span>
                                <span v-if="idx < visibleRecipientItems.length - 1">, </span>
                            </span>
                        </template>
                        <template v-else>-</template>
                    </span>
                    <span v-if="moreRecipientItems.length > 0" class="recipient-ellipsis">{{ ellipsisToken }}</span>
                    <!-- Show overflow count and tooltip only when there are hidden recipients -->
                    <RecipientTooltip v-if="moreRecipientItems.length > 0" :hoverMode="true" direction="bottom">
                        <template #trigger>
                            <span class="text-primary ml-1">+{{ moreRecipientItems.length }} more</span>
                        </template>
                        <template #text>
                            <div class="recipient-tooltip">
                                <div v-for="(recipient, idx) in moreRecipientItems" :key="idx" class="recipient-tooltip__item">
                                    <span class="recipient-tooltip__email">{{ recipient.email }}</span>
                                    <span v-if="isRecipientInactive(recipient)" class="recipient-inactive-label">(Inactive)</span>
                                </div>
                            </div>
                        </template>
                    </RecipientTooltip>
                </div>
            </div>
            <div class="mt-1 email-header-row">
                <span class="email-header-label">Subject:</span>
                <b class="email-header-value">{{ reportData.email_settings.subject }}</b>
            </div>
        </div>
    </div>

    <!-- Email Body -->
    <div class="email-body p-4 bg-white">
        <!-- Logo -->
        <div class="text-center mb-4" v-if="shouldShowLogo">
            <img :src="headerLogoUrl" alt="Logo" style="max-height: 50px;">
        </div>

        <!-- Content -->
        <div class="email-content mb-4" v-html="sanitizedBody"></div>

        <hr class="my-4" style="border-top: 1px solid #D7D7D7;">

        <!-- Footer Info -->
        <div class="text-muted" style="font-size: 12px;">
            <span style="color: #848484;">This automated report was scheduled by</span> <b>{{ reportData.created_by || 'Me' }}</b>
        </div>
        <hr class="my-4" style="border-top: 1px solid #D7D7D7;">

        <!-- Attachment Mockup -->
        <div class="attachment-mockup mt-3 p-3 border rounded d-flex align-items-center justify-content-between"
            style="background-color: #fff;height: 40px;">
            <div class="attachment-info d-flex align-items-center">
                <v-icon color="#757575" class="mr-2">mdi-file-document-outline</v-icon>
                <v-tooltip v-if="isAttachmentTruncated" bottom content-class="attachment-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            class="attachment-name"
                            v-bind="attrs"
                            v-on="on"
                            style="font-size: 14px; color: #3F3F3F;"
                            ref="attachmentName"
                        >
                            {{ attachmentName }}
                        </span>
                    </template>
                    <span>{{ attachmentName }}</span>
                </v-tooltip>
                <span v-else class="attachment-name" style="font-size: 14px; color: #3F3F3F;" ref="attachmentName">
                    {{ attachmentName }}
                </span>
            </div>
            <div class="badge badge-success px-2 attachment-badge"
                style="font-size: 14px; background-color: #3DA568; color: white;border-radius: 11px;">CSV</div>
        </div>
    </div>
</div>
